import React from 'react';
import PanelGroup from 'react-bootstrap/lib/PanelGroup';
import ServicePartSectionPanel from './ServicePartSectionPanel';

const ServiceConfigurator = (props) => {

    const { serviceSectionPartConfigs, activePanelIndex, onSelectedPartsChanged, onPanelClick, togglePart } = props

    const panels = serviceSectionPartConfigs.map((partsSection, index) => {
        return <ServicePartSectionPanel id={partsSection.id}
                                        key={partsSection.id}
                                        handleSelect={(index) => onPanelClick(index)}
                                        eventKey={index}
                                        partsSection={partsSection}
                                        expanded={activePanelIndex === index}
                                        togglePart={togglePart}
                                        onSelectedPartsChanged={onSelectedPartsChanged}/>
    });

    return <PanelGroup activeKey={activePanelIndex}>
        {panels}
    </PanelGroup>
}

export default ServiceConfigurator
